import React from "react";
import { ContactUsIcon } from "./Icons";
import { Link } from "react-router-dom";

function LPcontactUsForm({ eqid_link }) {
  return (
    <section
      id="MOcontactForm"
      className="bg-[#131F38] text-white px-4 md:px-8 py-10 md:py-12 w-full"
    >
      <div className="max-w-[1600px] mx-auto flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
        <div className="flex items-start gap-4 lg:flex-1">
          <span className="shrink-0 w-12 h-12 flex items-center justify-center bg-white/10">
            <ContactUsIcon />
          </span>
          <div>
            <h3 className="text-xl md:text-2xl font-bold mb-2">Contact us</h3>
            <p className="text-[#A9B4C7] text-sm md:text-base leading-relaxed">
              Tell us what you need for this machine and a specialist will come back to you,
              usually within one business day.
            </p>
          </div>
        </div>

        <div className="hidden lg:block w-px self-stretch bg-white/15" />

        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 lg:gap-5 lg:flex-none">
          <div className="border border-white/15 bg-white/5 px-5 py-4 sm:w-auto whitespace-nowrap">
            <b className="block text-[11px] font-bold tracking-widest text-[#8E9AAF] mb-1.5">
              PHONE
            </b>
            <Link
              to="tel:512-352-3694"
              className="text-white font-semibold hover:text-[#C9A227] transition-colors"
            >
              512-352-3694
            </Link>
          </div>
          <div className="border border-white/15 bg-white/5 px-5 py-4 sm:w-auto whitespace-nowrap">
            <b className="block text-[11px] font-bold tracking-widest text-[#8E9AAF] mb-1.5">
              PARTS
            </b>
            <a
              href="mailto:parts@choicebagging.com"
              className="text-white font-semibold hover:text-[#C9A227] transition-colors"
            >
              parts@choicebagging.com
            </a>
          </div>
          {eqid_link && (
            <div className="border border-white/15 bg-white/5 px-5 py-4 sm:w-auto whitespace-nowrap">
              <b className="block text-[11px] font-bold tracking-widest text-[#8E9AAF] mb-1.5">
                REFERENCE
              </b>
              <span className="font-mono text-white">EQID {eqid_link}</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default LPcontactUsForm;
